/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ================= 
Header固定でクラス付与
=================  */

document.addEventListener('DOMContentLoaded', function () {
  const siteHeader = document.getElementById('shopify-section-header');
  if (!siteHeader) return;

  let lastScrollY = window.scrollY;
  let enableScrollHandler = false;

  const siteHeaderHeight =
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    ) || 0;

  const delay = location.hash ? 600 : 0;
  setTimeout(() => {
    enableScrollHandler = true;
  }, delay);

  window.addEventListener('scroll', function () {
    if (!enableScrollHandler) return;

    if (window.scrollY > siteHeaderHeight) {
      siteHeader.classList.add('stickyed');
    } else {
      siteHeader.classList.remove('stickyed');
    }

    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const currentScrollY = Math.min(Math.max(window.scrollY, 0), maxScroll);

    const diff = currentScrollY - lastScrollY;

    if (Math.abs(diff) >= 10) {
      if (diff > 0) {
        siteHeader.classList.add('is-down');
      } else {
        siteHeader.classList.remove('is-down');
      }
      lastScrollY = currentScrollY;
    }
  });
});




/* ================= 
Header Account Drawer
=================  */
/*
const accountDrawer = document.getElementById('accountDrawer');
if (accountDrawer) {
  const toggleAccountDrawer = () => {    
    accountDrawer.classList.toggle('hidden');
  };
  document.querySelectorAll('.jsAccountDrawerButton')
    .forEach(btn => btn.addEventListener('click', toggleAccountDrawer));
  accountDrawer.addEventListener('click', toggleAccountDrawer);
}
*/

const accountDrawer = document.getElementById('accountDrawer');
if (accountDrawer) {
  const toggleAccountDrawer = () => {
    const isHidden = accountDrawer.classList.toggle('hidden');
    document.documentElement.classList.toggle('no-scroll', !isHidden);     
  };
  document.querySelectorAll('.jsAccountDrawerButton')
    .forEach(btn => btn.addEventListener('click', toggleAccountDrawer));
  accountDrawer.addEventListener('click', toggleAccountDrawer);
}

/* ================= 
商品一覧からカート追加
=================  */
document.addEventListener('click', function(event) {  
  const formSubmitButtons = event.target.closest('.ProductItem__FormSubmit');
  if (!formSubmitButtons) return;

  event.preventDefault();

  const parentForm = formSubmitButtons.closest('.ProductItem__Bottom').querySelector('.ProductItem__Form');
  if (!parentForm) return;

  const idValue = parentForm.querySelector('select[name="id"]').value;
  const quantityValue = parentForm.querySelector('select[name="quantity"]').value;

  const cartItem = {
    id: idValue,
    quantity: quantityValue
  };
  const bestBefore = formSubmitButtons.dataset.bestBefore;
  if (bestBefore) {
    cartItem.properties = { 賞味期限: bestBefore };
  }

  const formData = {
    items: [cartItem]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
      if (formSubmitButtons.dataset.redirect === 'cart') {
        window.location.href = '/cart';
      } else {
        document.dispatchEvent(
          new CustomEvent("product:added", {
            detail: { product: data }
          })
        );
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
});


/* ================= 
ProductItem AddToCart
=================  */
function ProductItem__FormVariant(obj) {
  var variant_value = obj.value;      
  // ============= 選択中のoption値取得 ============= 
  var options = obj.options;      
  for ( var i=0,l=options.length; l>i; i++ ) {
    if ( options[i].selected ) {
      var product_id = options[i].getAttribute('data-product_id')
      var product_tax = options[i].getAttribute('data-product_tax')        
      var case_quantity = options[i].getAttribute('data-case_quantity');
      var case_originprice = options[i].getAttribute('data-case_originprice');
      var price = options[i].getAttribute('data-price');
      var price_withouttax = options[i].getAttribute('data-price_withouttax');
      var compare_price = options[i].getAttribute('data-compare_price');
      var inventory_display = Number(options[i].getAttribute('data-inventory_display'));
      var inventory_quantity = Number(options[i].getAttribute('data-inventory_quantity'));
      var inventory_policy = options[i].getAttribute('data-inventory_policy');
      var available = options[i].getAttribute('data-available');
    }
  }
  // ============= 動的変更 ============= 
  let product_form = document.querySelector('.ProductItem__Form-' + product_id);
  let dom_PriceDictount = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__PriceDiscount');
  let dom_PriceWithoutTax = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__PriceWithoutTax');
  let dom_PriceTaxIn = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__PriceTaxIn');
  let dom_CaseOnePrice = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__CaseOnePrice');
  let dom_AddToCart = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__FormSubmit');
  let dom_InventoryQuantity = document.querySelector('.ProductItem__Form-' + product_id + ' .ProductItem__InventoryQuantity');
  //割引率の変更    
  if( compare_price > price || case_originprice ){      
    dom_PriceDictount.style.display = "inline-block";
    if( compare_price > price ){
      dom_PriceDictount.innerHTML = Math.floor(( 1 - ( price / compare_price ) ) * 100) + '%OFF';       
    }else if( case_originprice ){        
      dom_PriceDictount.innerHTML = Math.floor(( 1 - ( price / case_originprice ) ) * 100) + '%OFF';       
    }
  }else{
    dom_PriceDictount.style.display = "none";
    dom_PriceDictount.innerHTML = "";
  }  
  // 価格の変更（税別）  
  if( compare_price > price || case_originprice ){
    dom_PriceWithoutTax.innerHTML = '<span class="Price Price--highlight">¥' + Math.ceil(price_withouttax).toLocaleString() + '</span>';
  }else{
    dom_PriceWithoutTax.innerHTML = '<span class="Price">¥' + Math.ceil(price_withouttax).toLocaleString() + '</span>';
  }
  // 価格の変更（税込）
  dom_PriceTaxIn.innerHTML = '<span class="Price">¥' + Number(price).toLocaleString() + '</span>';
  // 1食あたりの価格変更
  if( case_quantity ){
    dom_CaseOnePrice.innerHTML = '1食あたり：¥' + (price / product_tax / case_quantity).toFixed(1);
  }else{
    dom_CaseOnePrice.innerHTML = "";
  }
  // 在庫数の変更
  if( inventory_display >= inventory_quantity && inventory_quantity >= 0){        
    dom_InventoryQuantity.innerHTML = inventory_quantity;
    dom_InventoryQuantity.style.display = "block";
  }else{        
    dom_InventoryQuantity.innerHTML = "";
    dom_InventoryQuantity.style.display = "none";
  }  
  // 売り切れ時    
  if( available == "false" ){      
    dom_AddToCart.disabled = true;
  }else{
    dom_AddToCart.disabled = false;
  }
}

/* ================= 
フッターのページTOPに戻るボタン
=================  */
document.getElementById("scrollTopBtn").onclick = function() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

/* ================= 
Custom Modal
=================  */
document.addEventListener("DOMContentLoaded", function () {
  const customModalButtons = document.querySelectorAll(".jsCustomModalButton");
  const customModals = document.querySelectorAll(".CustomModal");

  customModalButtons.forEach(button => {
      button.addEventListener("click", function () {
          const customModalTarget = this.getAttribute("data-target");
          const customModal = document.querySelector(`.CustomModal[data-target="${customModalTarget}"]`);
          if (customModal) {
            customModal.classList.add("is-active");
              document.documentElement.classList.add("no-scroll");
          }
      });
  });

  customModals.forEach(customModal => {
    customModal.addEventListener("click", function (event) {
          if (event.target.classList.contains("CustomModal__Close") || 
              event.target.classList.contains("CustomModal__Overlay")) {
                customModal.classList.remove("is-active");
              document.documentElement.classList.remove("no-scroll");
          }
      });
  });
});

/* ================= 
検索フォームで全角入力を半角入力に強制変換
=================  */
document.addEventListener("DOMContentLoaded", () => {
  const searchForms = document.querySelectorAll('form[action*="/search"]');

  searchForms.forEach((form) => {
    form.addEventListener("submit", () => {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      input.value = input.value
        .replace(/\u3000/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    });
  });
});


/* ================= 
「copy-protection」クラスのある画像を禁止対象
=================  */
document.addEventListener("contextmenu", function (e) {
  const img = e.target.closest("img.copy-protection");
  if (img) {
    e.preventDefault();
  }
});
document.addEventListener("dragstart", function (e) {
  const img = e.target.closest("img.copy-protection");
  if (img) {
    e.preventDefault();
  }
});

/* ================= 
コレクション・検索結果で非同期更新時、Revico再読み込み
=================  */
(function () {
  var selectors = [
    '.boost-pfs-filter-products',
    '.CollectionMain .CollectionInner__Products'
  ];
  var timer = null;

  function reloadRevico() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (window.revico && window.revico.global && window.revico.global.star) {
        window.revico.global.star.exec();
      }
    }, 200);
  }

  selectors.forEach(function (selector) {
    var target = document.querySelector(selector);
    if (!target) return;

    new MutationObserver(reloadRevico).observe(target, {
      childList: true,
      subtree: true
    });
  });
})();